<template>
  <div>
    <Link :title="$t('common.show')" :onClick="onClick">
      <p class="sub">
        <span v-for="item in summaryItems" :key="item.label">
          {{ item.count }} {{ item.label }}
        </span>
      </p>
    </Link>
  </div>
</template>

<script>
export default {
  name: 'UnitAndRoleLink',
  props: ['data'],
  data() {
    return {
    }
  },
  computed: {
    summaryItems() {
      const units = Array.isArray(this.data && this.data.units) ? this.data.units : [];
      const items = [
        { count: this.getCount(this.data && this.data.units), label: this.$t('common.units') },
        { count: this.getCount(this.data && this.data.roles), label: this.$t('common.roles') },
        {
          count: units.filter((unit) => Number(unit.is_department_owner) === 1).length,
          label: this.$t('department_owner'),
        },
        {
          count: units.filter((unit) => Number(unit.is_department_admin) === 1).length,
          label: this.$t('department_admin'),
        },
        { count: Number(this.data && this.data.is_company_admin) === 1 ? 1 : 0, label: this.$t('company_admin') },
        { count: Number(this.data && this.data.is_superadmin) === 1 ? 1 : 0, label: this.$t('user.superadmin') },
      ];

      return items.filter((item) => item.count > 0);
    },
  },
  methods: {
    getCount(value) {
      if (Array.isArray(value)) {
        return value.length;
      }
      return Number(value) || 0;
    },
    onClick() {
      this.$emit('open-dialog', this.data);
    }
  },
}
</script>

<style scoped>
.sub {
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
}
</style>
